import React from 'react';
import IconButton from '../atoms/IconButton';

const ShareLinks = ({ fromName }: { fromName: string }) => {
  const handleLineShare = () => {
    const currentUrl = window.location.href;
    const lineShareUrl = `https://line.me/R/msg/text/?${encodeURIComponent(currentUrl)}`;
    window.open(lineShareUrl, '_blank', 'width=600,height=400');
  };

  const handleXShare = () => {
    const currentUrl = window.location.href;
    const text = `${fromName}さんよりメッセージが届きました♪`;
    const xShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(currentUrl)}&hashtags=THELETTER,男の言葉は軽すぎる,本気の想いを届けよう`;
    window.open(xShareUrl, '_blank', 'width=600,height=400');
  };

  const handleCopyLink = async () => {
    const currentUrl = window.location.href;
    try {
      await window.navigator.clipboard.writeText(currentUrl);
      window.alert('URLをクリップボードにコピーしました。');
    } catch (err) {
      console.error('クリップボードへのコピーに失敗しました:', err);
      window.alert('URLのコピーに失敗しました');
    }
  };

  return (
    <div className='p-share-link u-mt60'>
      <IconButton
        icon={<img src='/img/common/ic-line.png' alt='LINE' />}
        text='LINEでシェア'
        onClick={handleLineShare}
      />
      <IconButton
        icon={<img src='/img/common/ic-x.png' alt='X' />}
        text='Xでシェア'
        onClick={handleXShare}
      />
      <IconButton
        icon={<img src='/img/common/ic-link.png' alt='コピー' />}
        text='リンクをコピー'
        onClick={handleCopyLink}
      />
    </div>
  );
};

export default ShareLinks;
